import { Text as e } from "../Typography/Typography.js";
import "../Typography/index.js";
import { Layout as t } from "../Layout/Layout.js";
import { SupportLink as n } from "../SupportLink/SupportLink.js";
import { CenteredContentLayout as r } from "../CenteredContentLayout/CenteredContentLayout.js";
import i from "./UnsupportedBrowserPage.module.js";
import { c as a } from "react/compiler-runtime";
import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { H1 as c } from "@jetbrains/ring-ui-built/components/heading/heading";
//#region src/components/UnsupportedBrowserPage/UnsupportedBrowserPage.tsx
var l = navigator?.userAgent ? /Edge?\/(13[6-9]|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Firefox\/(13[4-9]|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|Chrom(ium|e)\/(13[6-9]|1[4-9]\d|[2-9]\d{2}|\d{4,})\.\d+(\.\d+|)|(Maci|X1{2}).+ Version\/(18\.([4-9]|\d{2,})|(19|[2-9]\d|\d{3,})\.\d+)([,.]\d+|)( \(\w+\)|)( Mobile\/\w+|) Safari\/|(CPU[ +]OS|iPhone[ +]OS|CPU[ +]iPhone|CPU IPhone OS|CPU iPad OS)[ +]+(18[._]([4-9]|\d{2,})|(19|[2-9]\d|\d{3,})[._]\d+)([._]\d+|)/.test(navigator.userAgent) : !1, u = () => {
	let l = a(2), u;
	l[0] === Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ o(c, { children: "Qodana has dropped support for old browser versions" }), l[0] = u) : u = l[0];
	let d;
	return l[1] === Symbol.for("react.memo_cache_sentinel") ? (d = /* @__PURE__ */ o(t, {
		className: i.container,
		children: /* @__PURE__ */ o(r, { children: /* @__PURE__ */ s("div", {
			className: i.content,
			children: [u, /* @__PURE__ */ s("div", {
				className: i.subtitle,
				children: [
					/* @__PURE__ */ o(e, { children: "Please, consider updating your browser, or " }),
					/* @__PURE__ */ o(n, { label: "contact Qodana support" }),
					/* @__PURE__ */ o(e, { children: " if updating the browser is not a convenient option for you." })
				]
			})]
		}) })
	}), l[1] = d) : d = l[1], d;
};
//#endregion
export { l as IS_BROWSER_SUPPORTED, u as UnsupportedBrowserPage };
